import { useNavigate, useParams } from "react-router";
import EnterpriseService from "../../common/services/enterprise-service";
import { EnterpriseContext } from "./EnterpriseContext";
import { useContext, useEffect, useState } from "react";
import truckyService from "../../common/services/trucky-service";
import BoxDynamicAd from "../../ads/BoxDynamicAd";
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CompanyHero from "./CompanyHero";

export default function InvitePage({ container }) {
  const { globalContext, setGlobalContext } = useContext(EnterpriseContext);
  const [loadingData, setLoadingData] = useState(true);
  const { slug, code } = useParams();
  const es = new EnterpriseService();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    truckyService.setDocumentTitle("Company Invite");
  }, []);

  useEffect(() => {
    getInvite();
  }, [slug, code]);

  const getInvite = async () => {
    setLoadingData(true);
    try {
      const response = await es.getCompanyInvite(slug, code);
      if (response.success) {
        setInvite(response.invite);
      } else {
        setError(response.message);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoadingData(false);
    }
  };

  const acceptInvite = async () => {
    setLoadingData(true);
    try {
      const response = await es.accpetCompanyInvite(
        invite.company.id,
        invite.id
      );
      if (response.success) {
        await es.loadEnterpriseMemberData();
        setGlobalContext({
          member: es.member,
          company: es.company,
        });
        navigate("/vtchub");
      } else {
        setError(response.message);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <Row>
      <Col>
        <LoadingOverlay
          active={loadingData}
          spinner={
            <Spinner
              color="primary"
              style={{ width: "4rem", height: "4rem" }}
            ></Spinner>
          }
        >
          <Card>
            <CardBody>
              {error && <div className="alert alert-danger">{error}</div>}
              {invite && (
                <>
                  <CompanyHero company={invite.company}></CompanyHero>
                  <div className="fs-1 text-center h-300px flex flex-column justify-content-center align-items-center">
                    <div className="mt-10">
                      {container.localeManager.formatString(
                        container.localeManager.strings.youHaveInvited,
                        [invite.company?.name, invite.user?.name]
                      )}
                    </div>
                    <div className="mt-10">
                      <Button size="lg" color="success" onClick={acceptInvite}>
                        <FontAwesomeIcon icon="check"></FontAwesomeIcon>{" "}
                        {container.localeManager.strings.acceptAndJoin}
                      </Button>
                    </div>
                    <div className="mt-10 fs-3">
                      {container.localeManager.formatString(
                        container.localeManager.strings.acceptingYouWillBecome,
                        invite.company.name
                      )}
                    </div>
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </LoadingOverlay>
      </Col>
      <aside className="ad-column-placeholder">
        <BoxDynamicAd container={container} className="my-3" />
      </aside>
    </Row>
  );
}
